import React from 'react';
import PropTypes from 'prop-types';

import { GridList } from './ListComponents/GridList';

const ListWithGrid = ({ renderItem, items, minMaxWidth, gap, ...props }) => {
  return (
    <GridList minMaxWidth={minMaxWidth} gap={gap} {...props}>
      {items.map((item, index) => {
        return React.cloneElement(renderItem(item, index));
      })}
    </GridList>
  );
};

ListWithGrid.propTypes = {
  renderItem: PropTypes.func,
  items: PropTypes.array,
  minMaxWidth: PropTypes.string,
  gap: PropTypes.string,
};

ListWithGrid.defaultProps = {
  renderItem: () => {},
  items: [],
};

export default ListWithGrid;
